import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from 'applib-frontend';
import './style.less';
const TableLink = ({ text, state, projectId, url, }) => {
    const { intl } = useI18n();
    if (state === 'FAILED' && text === null) {
        return (_jsx("div", { className: "failed-task", children: intl.formatMessage({ id: 'failed_task' }) }));
    }
    if ((state === 'STOPPING' || state === 'FAILED') && text != null) {
        return text;
    }
    if (projectId != null) {
        return (_jsx("a", { href: `${url}/edit/${projectId}`, target: "_blank", rel: "noreferrer", children: text }));
    }
    return text !== null ? text : '';
};
export default TableLink;
